export default ($axios) => ({
    $axios,

    async fetch(type) {
        return await $axios.get(`/dialogs/${type}`)
    },

    async fetchById({
        id,
        type,
    }) {
        return await $axios.get(`/dialogs/${type}/${id}/messages`)
    },

    async fetchPrev({
        type,
        id,
        messageId,
    }) {
        return await $axios.get(`/dialogs/${type}/${id}/messages?before=${messageId}`)
    },

    async send({
        type,
        id,
    }, form) {
        return await $axios.post(`/dialogs/${type}/${id}/messages`, form)
    },

    async sendMedia({
        type,
        id,
    }, media) {
        return await $axios.post(`/dialogs/${type}/${id}/messages/image`, media)
    },

    async sendMediaToAll(media) {
        return await $axios.post('/dialogs/masters/send-all-masters/image', media)
    },

    async sentToAll(form) {
        return await $axios.post('/dialogs/masters/send-all-masters/text', form)
    },
})
